import { ReactNode } from 'react';
import { IconName } from '@connect-x-app/shared-types';
import { COLORS, PaperAirplane } from '@connect-x-app/shared-ui';

import { Icon } from '../icon/Icon';

import './EmptyState.scss';

type Props = {
  children?: ReactNode;
  className?: string;
  icon?: IconName;
  testId?: string;
};

export const EmptyState = ({ children, className = '', icon, testId = 'empty-state' }: Props) => {
  return (
    <div className={`empty-container ${className}`} data-test={testId}>
      <div className="empty-content-container">
        <img alt="empty-content" src={PaperAirplane} />
        <div className="empty-content-text-container">
          {icon ? <Icon className="empty-state-icon" colorName={COLORS.zulu.$08} name={icon} size={2.4} /> : null}
          {children}
        </div>
      </div>
    </div>
  );
};
